import { render } from "./9_cotidiana.vue?vue&type=template&id=52b00fb3&scoped=true"
import script from "./9_cotidiana.vue?vue&type=script&lang=js"
export * from "./9_cotidiana.vue?vue&type=script&lang=js"

import "./9_cotidiana.vue?vue&type=style&index=0&id=52b00fb3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b00fb3"]])

export default __exports__